import * as React from 'react';

import { Recipient } from 'api/api';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { SplitAddressCardUI } from '../address-list/split-address-card';

interface SplitDeliveryAddressButtonProps {
  address: Recipient;
  onTopBoxClick: () => void;
  onBottomBoxClick: () => void;
}

export const SplitDeliveryAddressButton: React.FC<SplitDeliveryAddressButtonProps> = ({
  address,
  onTopBoxClick,
  onBottomBoxClick,
}) => {
  const { tICU } = useTranslations();

  return (
    <SplitAddressCardUI
      address={address}
      /**
       * TODO: right now both of the buttons are doin the same action
       * in the future the recipient model will be splitted
       */
      onTopBoxClick={onTopBoxClick}
      onBottomBoxClick={onBottomBoxClick}
      topHeading={tICU('widget.delivery_address.CONTACT')}
      bottomHeading={tICU('widget.RECIPIENT_ADDRESS_HEADER')}
    />
  );
};
